export default {
  API: process.env.VUE_APP_ENDPOINT,
  DEFAULT_TITLE: 'Mikobi House',
  SHORT_DATE_FORMAT: "DD-MM-YYYY",
  DATE_FORMAT: "DD/MM/YYYY HH:mm:ss",
  SQL_DATE_FORMAT: "YYYY-MM-DD HH:mm:ss",
  PAGINATION: {
    page: 1,
    itemsPerPage: 20,
    mustSort: true,
    sortDesc: [1],
    sortBy: ["id"]
  },
  ITEMS_PER_PAGE:{
    'items-per-page-options': [10, 20, 30, 40, 50]
  },
  COLOR_CHART: {
    blue: '#4C84FF',
    blue_light: '#A9C4FF',
    red: '#0f7896',
    red_light: '#FE9FA5'
  },
  COMPARE_PERIOD: [
    'Previous period',
    'Previous month',
    'Previous year'
  ],
  CUSTOMER_STATUS: {
    InActive: 1,
    Actived: 2,
    Blocked: 3
  },
  CUSTOMER_STATUS_LIST: [
    { value: 1, name: 'Đã kích hoạt', color: '#0059b3' },
    { value: 2, name: 'Đang bị khóa', color: '#e63900' },
  ],
  DATA_TYPE: {
    String: 0,
    Number: 1,
    Enum: 2,
    Date: 3
  },
  LIST_COMPARISON: [
    { name: 'Có chứa', value: 'contain', display: '({0})', dataType: 0 },
    { name: 'Không chứa', value: 'does_not_contain', display: '-({0})', dataType: 0 },
    { name: 'Bằng', value: 's_equal', display: '= {0}', dataType: 0 },
    { name: 'Khác', value: 's_does_not_equal', display: '!= {0}', dataType: 0 },
    { name: 'Bằng', value: 'equal', display: '= {0}', dataType: 1 },
    { name: 'Khác', value: 'does_not_equal', display: '!= {0}', dataType: 1 },
    { name: 'Lớn hơn', value: 'greater_than', display: '> {0}', dataType: 1 },
    { name: 'Lớn hơn hoặc bằng', value: 'greater_than_or_equal', display: '>= {0}', dataType: 1 },
    { name: 'Nhỏ hơn', value: 'less_than', display: '< {0}', dataType: 1 },
    { name: 'Nhỏ hơn hoặc bằng', value: 'less_than_or_equal', display: '<= {0}', dataType: 1 },
    { name: 'Bằng', value: 'in', display: '= [{0}]', dataType: 2 },
    { name: 'Khác', value: 'not_in', display: '!= [{0}]', dataType: 2 },
    { name: 'Bằng', value: 'd_equal', display: '= {0}', dataType: 3 },
    { name: 'Khác', value: 'd_does_not_equal', display: '!= {0}', dataType: 3 },
    { name: 'Lớn hơn', value: 'd_greater_than', display: '> {0}', dataType: 3 },
    { name: 'Lớn hơn hoặc bằng', value: 'd_greater_than_or_equal', display: '>= {0}', dataType: 3 },
    { name: 'Nhỏ hơn', value: 'd_less_than', display: '< {0}', dataType: 3 },
    { name: 'Nhỏ hơn hoặc bằng', value: 'd_less_than_or_equal', display: '<= {0}', dataType: 3 },
  ],
  ROLE_TYPE: {
    Admin: 1,
    Manager: 2,
    Accountant: 4,
    Sale: 8,
    CustomerSercice: 16
  },
  ROLES: [
    { value: 1, name: 'Admin', modules: 511},
    { value: 2, name: 'Quản lý', modules: 511},
    { value: 4, name: 'Kế toán', modules: 189},
    { value: 8, name: 'Kinh doanh', modules: 349},
    { value: 16, name: 'CSKH', modules: 381}
  ],
  ORDER_STATUS: [
    { value: 'chua_mua_hang', name: 'Chưa mua hàng', color: '#68b9f7'},
    { value: 'cho_mua_hang', name: 'Chờ mua hàng', color: '#2287e6'},
    { value: 'da_mua_hang', name: 'Đã mua hàng', color: '#3622e6'},
    { value: 'khach_huy_don', name: 'Khách huỷ đơn', color: '#e63900'},
    { value: 'admin_huy_don', name: 'Admin huỷ đơn', color: '#e69922'},
    { value: 'het_hang', name: 'Không mua được', color: '#0059b3'},
    { value: 'don_rieng', name: 'Đơn riêng', color: '#0059b3'},
    { value: 'het_sale_doi_back', name: 'Hàng hết sale đợi back', color: '#b30000'},
  ],
  ORDER_SHIPMENT_STATUS: [
    { value: 'cho_phat_hang', name: ''},
    // { value: 'hang_dang_ve', name: 'Hàng đang về'},
    { value: 'hang_ve_du', name: 'Hàng về đủ'},
    { value: 'hang_ve_thieu', name: 'Hàng thiếu còn về'},
    { value: 'khong_ve_nua', name: 'Không về nữa'},
  ],
  RECEIPT_DRAFT: [
    { value: 0, name: 'Đơn xuất', color: '#3622e6'},
    { value: 1, name: 'Đơn nháp', color: '#e63900' }
  ],
};